import type { Theme } from 'theme-ui';

// This type interaction ensures that all responsive values must be updated when new breakpoints are added!
// Caveat here is that responsive arrays need one more value than the breakpoint array - the initial size below the lowest breakpoint;
type Breakpoints<V> = [V, V, V, V];
type ResponsiveArray<V> = [V, ...Breakpoints<V>];

export type Responsive<V> = V | ResponsiveArray<V | null>;

// 0, 390px, 640px, 1024px, 1440px
const breakpoints: Breakpoints<string> = ['390px', '640px', '1024px', '1440px'];

export const r = <V>(base: V | null, { sm, md, lg, xl }: { sm?: V; md?: V; lg?: V; xl?: V }): Responsive<V> => [
    base,
    sm ?? null,
    md ?? null,
    lg ?? null,
    xl ?? null,
];

export const theme: Theme = {
    breakpoints,
    colors: {
        ink: '#0C1435',
    },
};
